import React, { ReactNode } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import Button from '../../../../common/Button';
import { PAIR_DEVICE_TWO } from '../../../../../routes';
import appleIcon from '../../../../../img/home/apple.png';
import googleIcon from '../../../../../img/home/google.png';
import { DownloadAppUrlDTO } from '../../../../../network/api/types/compte/DownloadAppUrlDTO';
import compteApi from '../../../../../network/api/compteApi';

type Props = RouteComponentProps & {
  onClose: () => void
};

type State = {
  appUrls: DownloadAppUrlDTO
};

class PairDeviceStepOne extends React.Component<Props> {
  state: State = {
    appUrls: null,
  };

  componentDidMount(): void {
    compteApi.fetchAppUrls()
      .then((appUrls) => this.setState({ appUrls }));
  }

  handleNext = () => {
    this.props.history.push(PAIR_DEVICE_TWO);
  };

  render(): ReactNode {
    return (
      <>
        <div className="download-step-container">
          <div className="subtitle">
            <Translate value="PAIR_DEVICE.STEP_ONE" />
          </div>
          <div className="download-instructions">
            <Translate value="PAIR_DEVICE.INSTRUCTION_START" />
            <Translate value="PAIR_DEVICE.APP_NAME" />
            <Translate value="PAIR_DEVICE.INSTRUCTION_END" />
          </div>
          <div className="download-container">
            <div className="download-buttons button-container">
              {this.state.appUrls && (
              <>
                <a href={this.state.appUrls.apple} target="_blank" rel="noreferrer noopener">
                  <button type="button" className="button">
                    <div className="download-icon">
                      <img
                        className="download-img"
                        src={appleIcon}
                        alt="apple-img"
                      />
                    </div>
                    <div className="download-text">
                      <Translate value="PAIR_DEVICE.DOWNLOAD_ON" />
                      <Translate value="PAIR_DEVICE.APPLE" />
                    </div>
                  </button>
                </a>
                <a href={this.state.appUrls.google} target="_blank" rel="noreferrer noopener">
                  <button type="button" className="button">
                    <div className="download-icon">
                      <img
                        className="download-img"
                        src={googleIcon}
                        alt="google-play-img"
                      />
                    </div>
                    <div className="download-text">
                      <Translate value="PAIR_DEVICE.DOWNLOAD_ON" />
                      <Translate value="PAIR_DEVICE.GOOGLE" />
                    </div>
                  </button>
                </a>
              </>
              )}
            </div>
            <div className="after-download">
              <Translate value="PAIR_DEVICE.CONTINUE" />
            </div>
          </div>
        </div>
        <div className="button-container">
          <Button
            type="third"
            onClick={this.props.onClose}
            i18nKey="actions.CANCEL"
          />
          <Button
            type="primary"
            onClick={this.handleNext}
            i18nKey="actions.CONTINUE"
          />
        </div>
      </>
    );
  }
}

export default withRouter(PairDeviceStepOne);
